import Button from '../../UI/button'
import ModalCustom from '../../UI/modal'

type Props = {
	show: boolean
	handleClose: () => void
}
const DeleteAccountModal = ({show, handleClose}: Props) => {
  return (
	<ModalCustom className='delete-account-modal' show={show} onHide={handleClose} title="We're sorry to see you go...">
		<p>Deleting your account is permanent and means you won't be able to get your data back. All your account data will be deleted.</p>
		<p>We'll delete your account and delete your Travel Hearts account data after 14 days. If you change your mind before 14 days are up, log in with your email and password and we'll send you a link to reactivate your account.</p>
		<div className='delete-account-modal-actions'>
			<Button variant='dark' px={70} onClick={handleClose}>Cancel</Button>
			<Button variant='primary' px={70}>Delete</Button>
		</div>
	</ModalCustom>
  )
}
export default DeleteAccountModal